import { render } from "./Collection.vue?vue&type=template&id=0e5e92d9&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=0e5e92d9&scoped=true&lang=css"
import "./Collection.vue?vue&type=style&index=1&id=0e5e92d9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5e92d9"]])

export default __exports__